import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Shield.svg",
  "use": "Shield.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Shield.svg\"><path d=\"M14.0208,14.0208A27.9135,27.9135,0,0,0,30.7294,8.4939a1.9991,1.9991,0,0,1,2.5828,0,28.1828,28.1828,0,0,0,16.7086,5.5269,2,2,0,0,1,2,2c0,22.06-5.9326,34.35-19.2357,39.8486a2.0049,2.0049,0,0,1-1.5286,0C17.9533,50.37,12.0208,38.08,12.0208,16.0208A2,2,0,0,1,14.0208,14.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol